import React from 'react'

export default function LOADING() {
    return (
        <>
            <div className="lds-heart loading hide"><div></div></div>
        </>
    )
}
